import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../authentication.service';
import { UserService } from '../../users/user.service';
import { DataService } from '../data.service';

@Component({
  selector: 'toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  providers: [UserService]
})
export class ToolbarComponent implements OnInit {
  @Input() color = '#ffffff';
  @Input() sidebar = false;
  @Input() userDropdown = true;
  @Input() menuButton = false;
  user;
  userState = false;
  userStates = [
    { label: 'Active', value: 'active', disabled: true },
    { label: 'Inactive', value: 'inactive' }
  ]
  menuOptions = [];
  errors;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.user = this.authenticationService.user();
    this.menuOptions = [
      { name: 'Account', action: '/profile', link: true },
      { name: 'Logout', action: '/logout', link: true }
    ];
    this.setUserState(this.user && this.user.status);
  }

  isLoggedIn(): boolean {
    return this.authenticationService.isLoggedIn();
  }

  setClasses() {
    return {
      [this.color]: this.color
    };
  }

  setUserState(event) {
    let value = false;
    let target = event && event.target || event;
    if (target && target.id === 'user_state_active') {
      value = true;
    } else if (target === true) {
      value = target;
    }

    this.userState = value;
    let stateChange = this.authenticationService.updateUserState(this.userState);
    if (stateChange) {
      stateChange.subscribe(res => {
        this.dataService.changeData({status: this.userState});
      }, err => {
        //
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/toolbar/toolbar.component.ts